import { push } from 'react-router-redux'
import * as globalActions from 'artist-portal-actions'
import { ARTIST_PORTAL_ROUTE } from 'config'

export function signOut() {
  return function (dispatch) {
    dispatch(clearDetails())
    dispatch(push(ARTIST_PORTAL_ROUTE))
  }
}

export function clearDetails() {
  return function (dispatch) {
    dispatch(globalActions.setAuthenticated({ token: null }))
    dispatch(globalActions.setIsAdmin(false))
    dispatch(globalActions.setCurrentArtistId(null))
    dispatch(globalActions.clearArtist())
  }
}
